import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function About() {
  return <section className="py-24 bg-white" data-id="element-9">
      <div className="max-w-7xl mx-auto px-6" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-11">
          {/* Image Side */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative h-[600px]" data-id="element-12">
            <img src="https://images.unsplash.com/photo-1563720223185-11003d516935?q=80&w=2070&auto=format&fit=crop" alt="Showroom Mercedes" className="w-full h-full object-cover rounded-2xl" data-id="element-13" />
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-gray-100 rounded-2xl -z-10 hidden lg:block" data-id="element-14" />
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-15">
            <h4 className="text-[#D4AF37] tracking-widest uppercase text-sm mb-4" data-id="element-16">
              Về Chúng Tôi
            </h4>
            <h2 className="text-4xl md:text-5xl font-light text-black mb-8 leading-tight" data-id="element-17">
              MERCEDES-BENZ <br data-id="element-18" /> VIỆT NAM
            </h2>
            <p className="text-gray-600 font-light leading-relaxed mb-6 text-lg" data-id="element-19">
              Từ khi thành lập, chúng tôi cam kết mang đến trải nghiệm xe sang
              đẳng cấp nhất cho khách hàng Việt Nam. Showroom của chúng tôi
              không chỉ là nơi mua xe, mà là không gian trải nghiệm nghệ thuật ô
              tô đích thực.
            </p>
            <p className="text-gray-600 font-light leading-relaxed mb-10" data-id="element-20">
              Hãy trải nghiệm tương lai của di chuyển với dòng xe đa dạng của
              chúng tôi, từ dòng thể thao AMG đến dòng siêu sang Maybach.
            </p>

            {/* Registration Form */}
            <div className="bg-gray-50 p-8 border border-gray-100 rounded-2xl" data-id="element-21">
              <h3 className="text-xl font-light mb-6" data-id="element-22">Đăng Ký Tư Vấn</h3>
              <form className="space-y-4" data-id="element-23">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-24">
                  <input type="text" placeholder="Họ và tên" className="w-full bg-white border border-gray-200 p-3 rounded-lg focus:outline-none focus:border-black transition-colors font-light" data-id="element-25" />
                  <input type="tel" placeholder="Số điện thoại" className="w-full bg-white border border-gray-200 p-3 rounded-lg focus:outline-none focus:border-black transition-colors font-light" data-id="element-26" />
                </div>
                <input type="email" placeholder="Email của bạn" className="w-full bg-white border border-gray-200 p-3 rounded-lg focus:outline-none focus:border-black transition-colors font-light" data-id="element-27" />
                <Button variant="primary" className="w-full" data-id="element-28">
                  Gửi Yêu Cầu
                </Button>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}